import React from "react";
import { Pagination } from "@mui/material";

const CustomPagination = ({ totalPages, currentPage, onChange }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Pagination
        count={totalPages} // total pages
        page={currentPage} // current page
        onChange={(e, value) => onChange(value)} // when page changes
  // color="primary"
        shape="rounded"
        sx={{
          "& .MuiPaginationItem-root": {
            color: "#0fb7a4", // text color
            
          },
          "& .Mui-selected": {
            backgroundColor: "#0fb7a4", // selected bg
            color: "#fff",
            fontWeight: "bold",
          },
        }}
      />
    </div>
  );
};

export default CustomPagination;
